// extracted by mini-css-extract-plugin
export default {"submit_btn":"styles_submit_btn__S1CMC"};